// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomQuoteModel } from "@ces/App/Services/QuoteService";
import { CustomAppState } from "@ces/App/Store/Reducers";
import { GetQuotesApiParameter } from "@insite/client-framework/Services/QuoteService";
import { DataView, DataViewState, getById, getDataView } from "@insite/client-framework/Store/Data/DataState";
import { SalespersonModel } from "@insite/client-framework/Types/ApiModels";

export interface CustomQuotesDataView extends DataView {
    salespersonList: SalespersonModel[] | null;
}

export interface CustomQuotesState extends DataViewState<CustomQuoteModel, DataView> {}

export function getCustomQuotesDataView(state: CustomAppState, getQuotesApiParameter: GetQuotesApiParameter) {
    return getDataView<CustomQuoteModel, DataView>(state.xCustomQuotes, getQuotesApiParameter);
}

export function getCustomQuoteState(state: CustomAppState, quoteNumber: string | undefined) {
    return getById(state.xCustomQuotes, quoteNumber);
}
